import React, { useContext, useEffect, useState } from "react";

import { Row, Col, Container, Modal } from "react-bootstrap";
import { Link, useHistory } from "react-router-dom";
import Search from "../../components/Search/Search";
import AccountDropdown from "../../components/AccountDropdown/AccountDropdown";
import ActivityLog from "../../components/ActivityLog/ActivityLog";
import NotificationLog from "../../components/ActivityLog/NotificationLog";
import AccountImg from "../../assets/images/Account.png";
import JournyImg from "../../assets/images/journyImg.jpg";
import JournyImg1 from "../../assets/images/journyImg1.jpg";
import JournyImg2 from "../../assets/images/journyImg2.jpg";
import JournyImg3 from "../../assets/images/journyImg3.jpg";
import journyImg4 from "../../assets/images/journyImg4.jpg";
import JournyImg5 from "../../assets/images/journyImg5.jpg";
import JournyImg6 from "../../assets/images/journyImg6.jpg";
import JournyImg7 from "../../assets/images/journyImg7.jpg";
import journyImg8 from "../../assets/images/journyImg8.jpg";
import JournyImg9 from "../../assets/images/journyImg9.jpg";
import JournyImg10 from "../../assets/images/journyImg10.jpg";
import journyImg11 from "../../assets/images/journyImg11.jpg";
import journyImg12 from "../../assets/images/journyImg12.jpg";
import JournyImg13 from "../../assets/images/journyImg13.jpg";
import JournyImg14 from "../../assets/images/journyImg14.jpg";
import journyImg15 from "../../assets/images/journyImg15.jpg";
import NoData from "../../components/EmptyState/NoData.jsx";
import {
  MyLearing,
  Alerts,
  SideArrow,
} from "../../icons/Icons";
//import { AuthContext } from "../providers/AuthProvider";
import { AuthContext } from "../../providers/authProvider";
import UpdatePassword from "./UpdatePassword";
import { getUserProfileAsync, getEmployeeAssignmentsAsync } from "../../reducers/user-reducers";
import { getHelpdeskNumbersAsync } from "../../reducers/dashboard-reducers";
import { useDispatch } from "react-redux";
import { getFormatDate } from "../../common";
import { mapStatusToValue } from "../../common";
import Slider from "react-slick";
import 'slick-carousel/slick/slick.css';
//import 'slick-carousel/slick/slick-theme.css';
import getInitialsInName from "../../helper/GetNameInitials";
import UserImage from "../../components/UserImage/UserImage";
import Loader from "../../components/Loader/Loader";
import EmpDashboardCardLarge from "./EmpDashboardCards/EmpDashboardCardLarge";
import EmpDashboardCard from "./EmpDashboardCards/EmpDashboardCard";
import DateTimeConverter from "../../components/DateTimeConverter/DateTimeConverter";
import SwitchDashboard from "./SwitchDashboard.jsx";

const EmployeeDashboard = () => {
  const dispatch = useDispatch();
  const authService = useContext(AuthContext);
  const userProfile = authService.getUserProfile();
  const [userProfiles, setUserProfiles] = useState(null);
  const [updatePassword, setUpdatePassword] = useState(false);
  const [employeeAssignment, setEmployeeAssignment] = useState(null);
  const [settings, setSettings] = useState();
  const [searchString, setSearchString] = useState("");
  const [filteredEmployees, setFilteredEmployees] = useState([]);
  const [helpdeskDetail, setHelpdeskDetail] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const filteredEmployees = employeeAssignment?.assignments?.filter((employee) => {
      const nameMatch = employee.title.toLowerCase().includes(searchString.toLowerCase());
      const statusMatch = employee.status === 2 || employee.status === 3;
      return nameMatch && statusMatch;
    });
    // filteredEmployees && filteredEmployees.sort((a, b) => {
    //   const dateA = new Date(a.assignedOn);
    //   const dateB = new Date(b.assignedOn);
    //   return dateB - dateA; // Note the reversal here
    // });
    setFilteredEmployees(filteredEmployees);
  }, [searchString, employeeAssignment]);


  useEffect(() => {
    getUserProfile();
    getEmployeeAssignment();
    getHelpDeskData();

    setSettings({
      centerMode: false,
      centerPadding: "1.25rem",
      slidesToShow: 3,
      speed: 500,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      infinite: false,
      lazyLoadEager: 1,
      lazyLoad: "ondemand",
      responsive: [
        {
          breakpoint: 1340,
          settings: {
            //arrows: false,
            slidesToShow: 4,
          },
        },
        {
          breakpoint: 900,
          settings: {
            //arrows: false,
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 860,
          settings: {
            // arrows: false,
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 676,
          settings: {
            //arrows: false,
            slidesToShow: 1,
            adaptiveHeight: true,
            centerPadding: "0px",
          },
        },
      ],
    });
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 1500);
  });


  const getEmployeeAssignment = () => {
    dispatch(getEmployeeAssignmentsAsync()).then((res) => {
      if (res.payload) {
        setEmployeeAssignment(res.payload);
      }
    });
  };

  const getHelpDeskData = () => {
    dispatch(getHelpdeskNumbersAsync()).then((res) => {
      console.log(res, 'res')
      if (res.payload) {
        setHelpdeskDetail(res.payload);
      }
    });
  };

  const getUserProfile = () => {
    dispatch(getUserProfileAsync()).then((res) => {
      if (res.payload) {
        setUpdatePassword(res.payload?.onFirstLogin)
        setUserProfiles(res.payload);
      }
    });
  };
  const availableImages = [
    JournyImg1,
    JournyImg2,
    JournyImg3,
  ];
  // console.log(userProfiles,'userProfiles');
  const imageSources = [JournyImg, JournyImg1, JournyImg2, JournyImg3, journyImg4, JournyImg5, JournyImg6, JournyImg7, journyImg8, JournyImg9, JournyImg10, journyImg11, journyImg12, JournyImg13, JournyImg14, journyImg15];
  const randomIndex = Math.floor(Math.random() * imageSources.length);
  const randomImage = imageSources[randomIndex];
  console.log(filteredEmployees,'filteredEmployees');

  return (
    <>
      {/* {userProfiles && userProfiles?.roleName === "Employee" && ( */}
      {userProfiles && userProfiles?.switchedRoleName === "Employee" && (
        <>
          <div className="pages">
            {isLoading && (
              <div className="loader-container bg-white">
                <Loader />
              </div>
            )}
            <header className="pageHeader">
              <Container fluid className="px-40">
                <Row className="mx-0 align-items-center">
                  <Col className="px-0">
                    <h3>Dashboard</h3>
                    <h6 className="font-normal text-gray-200 pt-1">
                      👋 Welcome to your Dashboard, {userProfiles?.name}!
                    </h6>
                  </Col>
                  <Col className="px-0 text-end ">
                    <div className="d-flex gap-3 align-items-center justify-content-end">
                    {userProfiles && (userProfiles?.roleName === "Admin"  || userProfiles?.roleName === "Super Admin") && (
                    <SwitchDashboard userProfiles={userProfiles}/>
                    )}
                      <div className=''><Search placeHolder='Search...' onBlur={setSearchString} />
                      </div>
                      <AccountDropdown />
                      <NotificationLog />
                      {/* <ActivityLog /> */}
                    </div>
                  </Col>
                </Row>
              </Container>
            </header>

            <div className="pageOuter">
              <Container fluid className="px-40">

                <div className="pageOuter1 d-flex flex-grow-1">

                  <Row className="flex-grow-1 w-100">
                    <Col lg={4} className="flex-column emhead d-flex">
                      <div className="page mb-2 flex-grow-0">

                        <Row className="g-0 p-20 pb-0">
                          <Col lg={12} className="">
                            <h5 className="mb-2 pb-1">Status of my Learning</h5>
                          </Col>
                        </Row>
                        {employeeAssignment && employeeAssignment.totalAssigned ? (
                          <>
                            <Row className="g-0 p-20 borderBottom py-0 align-items-center">
                              <Col lg={6} className="">
                                <div>

                                  <p className="m-0 h2 f24 text-gray-200"><span className="h1 f40 text-secondary-400 font-bold">{employeeAssignment?.completed}</span>/{employeeAssignment?.totalAssigned}</p>

                                </div>
                                {/* <svg width="88" height="33" viewBox="0 0 88 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M10.983 30.3977C8.97538 30.3977 7.18561 30.0284 5.61364 29.2898C4.05114 28.5511 2.81061 27.5331 1.89205 26.2358C0.973485 24.9384 0.495265 23.4517 0.457386 21.7756H6.4233C6.48958 22.9025 6.96307 23.8163 7.84375 24.517C8.72443 25.2178 9.77083 25.5682 10.983 25.5682C11.9489 25.5682 12.8011 25.3551 13.5398 24.929C14.2879 24.4934 14.8703 23.892 15.2869 23.125C15.7131 22.3485 15.9261 21.4583 15.9261 20.4545C15.9261 19.4318 15.7083 18.5322 15.2727 17.7557C14.8466 16.9792 14.2547 16.3731 13.4972 15.9375C12.7396 15.5019 11.8731 15.2794 10.8977 15.2699C10.0455 15.2699 9.21686 15.4451 8.41193 15.7955C7.61648 16.1458 6.99621 16.6241 6.55114 17.2301L1.08239 16.25L2.46023 0.90909H20.2443V5.9375H7.53125L6.77841 13.2244H6.94886C7.46023 12.5047 8.23201 11.9081 9.2642 11.4347C10.2964 10.9612 11.4517 10.7244 12.7301 10.7244C14.482 10.7244 16.0445 11.1364 17.4176 11.9602C18.7907 12.7841 19.875 13.9157 20.6705 15.3551C21.4659 16.785 21.8589 18.4328 21.8494 20.2983C21.8589 22.2585 21.4044 24.0009 20.4858 25.5256C19.5767 27.0407 18.303 28.2339 16.6648 29.1051C15.036 29.9669 13.142 30.3977 10.983 30.3977ZM37.5455 30.6392C35.1023 30.6297 33 30.0284 31.2386 28.8352C29.4867 27.642 28.1373 25.9138 27.1903 23.6506C26.2528 21.3873 25.7888 18.6648 25.7983 15.483C25.7983 12.3106 26.267 9.60701 27.2045 7.37216C28.1515 5.13731 29.5009 3.4375 31.2528 2.27273C33.0142 1.09848 35.1117 0.511363 37.5455 0.511363C39.9792 0.511363 42.072 1.09848 43.8239 2.27273C45.5852 3.44697 46.9394 5.15151 47.8864 7.38636C48.8333 9.61174 49.3021 12.3106 49.2926 15.483C49.2926 18.6742 48.8191 21.4015 47.8722 23.6648C46.9347 25.928 45.59 27.6562 43.8381 28.8494C42.0862 30.0426 39.9886 30.6392 37.5455 30.6392ZM37.5455 25.5398C39.2121 25.5398 40.5426 24.7017 41.5369 23.0256C42.5313 21.3494 43.0237 18.8352 43.0142 15.483C43.0142 13.2765 42.7869 11.4394 42.3324 9.97159C41.8873 8.50379 41.2528 7.40057 40.429 6.66193C39.6146 5.9233 38.6534 5.55398 37.5455 5.55398C35.8883 5.55398 34.5625 6.38258 33.5682 8.03977C32.5739 9.69697 32.072 12.178 32.0625 15.483C32.0625 17.7178 32.285 19.5833 32.7301 21.0795C33.1847 22.5663 33.8239 23.6837 34.6477 24.4318C35.4716 25.1705 36.4375 25.5398 37.5455 25.5398Z" fill="#E3828D" />
                          <path d="M58.9908 11.7273L53.3658 32.625H51.9425L57.5675 11.7273H58.9908ZM66.9553 30.2386C65.8416 30.2386 64.8501 30.0284 63.9808 29.608C63.1115 29.1875 62.4297 28.6136 61.9354 27.8864C61.4411 27.1534 61.1939 26.3267 61.1939 25.4062C61.1939 24.6847 61.3445 24.0114 61.6456 23.3864C61.9467 22.7557 62.3615 22.2273 62.8899 21.8011C63.4183 21.3693 64.0121 21.0881 64.6712 20.9574V20.8636C63.8132 20.6136 63.1229 20.1222 62.6001 19.3892C62.0774 18.6506 61.8189 17.8125 61.8246 16.875C61.8189 16.0057 62.0405 15.2273 62.4893 14.5398C62.9382 13.8523 63.549 13.3097 64.3217 12.9119C65.1001 12.5085 65.978 12.3068 66.9553 12.3068C67.9268 12.3068 68.799 12.5085 69.5717 12.9119C70.3445 13.3097 70.9553 13.8523 71.4041 14.5398C71.8587 15.2273 72.0888 16.0057 72.0945 16.875C72.0888 17.8068 71.8246 18.6449 71.3018 19.3892C70.7791 20.1278 70.0916 20.6193 69.2393 20.8636V20.9574C69.8984 21.0824 70.4893 21.3608 71.0121 21.7926C71.5348 22.2244 71.9496 22.7557 72.2564 23.3864C72.5632 24.0114 72.7166 24.6847 72.7166 25.4062C72.7166 26.3267 72.4666 27.1534 71.9666 27.8864C71.4723 28.6136 70.7905 29.1875 69.9212 29.608C69.0575 30.0284 68.0689 30.2386 66.9553 30.2386ZM66.9553 28.8068C67.7848 28.8068 68.5121 28.6591 69.1371 28.3636C69.7678 28.0625 70.2592 27.6506 70.6115 27.1278C70.9695 26.6051 71.1484 26.0057 71.1484 25.3295C71.1484 24.6307 70.9638 24.0085 70.5945 23.4631C70.2251 22.9119 69.7251 22.4773 69.0945 22.1591C68.4638 21.8352 67.7507 21.6733 66.9553 21.6733C66.1598 21.6733 65.4439 21.8352 64.8075 22.1591C64.1768 22.4773 63.6768 22.9119 63.3075 23.4631C62.9439 24.0085 62.7621 24.6307 62.7621 25.3295C62.7621 26.0057 62.9354 26.6051 63.282 27.1278C63.6342 27.6506 64.1257 28.0625 64.7564 28.3636C65.3928 28.6591 66.1257 28.8068 66.9553 28.8068ZM66.9553 20.3097C67.6371 20.3097 68.2479 20.1648 68.7876 19.875C69.3274 19.5852 69.7536 19.1903 70.0661 18.6903C70.3842 18.1847 70.5462 17.6108 70.5518 16.9688C70.5462 16.3324 70.3871 15.7699 70.0746 15.2812C69.7621 14.7869 69.3359 14.4034 68.7962 14.1307C68.2621 13.8523 67.6484 13.7131 66.9553 13.7131C66.2621 13.7131 65.6428 13.8523 65.0973 14.1307C64.5575 14.4034 64.1314 14.7869 63.8189 15.2812C63.5121 15.7699 63.3615 16.3324 63.3672 16.9688C63.3615 17.6108 63.5149 18.1847 63.8274 18.6903C64.1456 19.1903 64.5746 19.5852 65.1143 19.875C65.6598 20.1648 66.2734 20.3097 66.9553 20.3097ZM81.6761 30.2386C80.4489 30.2386 79.4006 29.8864 78.5312 29.1818C77.6676 28.4716 77.0028 27.446 76.5369 26.1051C76.0767 24.7642 75.8466 23.1534 75.8466 21.2727C75.8466 19.3977 76.0767 17.7926 76.5369 16.4574C77.0028 15.1165 77.6705 14.0909 78.5398 13.3807C79.4148 12.6648 80.4602 12.3068 81.6761 12.3068C82.892 12.3068 83.9347 12.6648 84.804 13.3807C85.679 14.0909 86.3466 15.1165 86.8068 16.4574C87.2727 17.7926 87.5057 19.3977 87.5057 21.2727C87.5057 23.1534 87.2727 24.7642 86.8068 26.1051C86.3466 27.446 85.6818 28.4716 84.8125 29.1818C83.9489 29.8864 82.9034 30.2386 81.6761 30.2386ZM81.6761 28.8068C83.0227 28.8068 84.0739 28.1506 84.8295 26.8381C85.5852 25.5199 85.9631 23.6648 85.9631 21.2727C85.9631 19.6818 85.7898 18.3239 85.4432 17.1989C85.1023 16.0682 84.6108 15.2045 83.9688 14.608C83.3324 14.0114 82.5682 13.7131 81.6761 13.7131C80.3409 13.7131 79.2926 14.3778 78.5312 15.7074C77.7699 17.0312 77.3892 18.8864 77.3892 21.2727C77.3892 22.8636 77.5597 24.2216 77.9006 25.3466C78.2472 26.4716 78.7386 27.3295 79.375 27.9205C80.017 28.5114 80.7841 28.8068 81.6761 28.8068Z" fill="#646464" />
                        </svg> */}

                                <p className="text-sm m-0 text-gray-100 d-block pt-2">Yay! Continue on your journey of learning and growing. </p>
                              </Col>
                              <Col lg={6} className="text-end">
                                <MyLearing />
                              </Col>
                            </Row>
                            <Row className="g-0 p-20 bg-gray-600">
                              <Col><span className="h2 font-medium d-block">{employeeAssignment?.active}</span><span className="text-sm">Active</span></Col>
                              <Col><span className="h2 font-medium d-block">{employeeAssignment?.completed}</span><span className="text-sm">Completed</span></Col>
                              <Col><span className="h2 font-medium d-block">{employeeAssignment?.delayed}</span><span className="text-sm">Delayed</span></Col>
                            </Row>
                          </>) : (

                        <div className="d-flex align-items-center justify-content-center eptyFlex">
                            <NoData
                            msgicon={'status'}
                            message={'Status of your Modules completion will be listed here.'}
                          />
                        </div>
                        )}
                      </div>
                      <div className="page mt-1">
                        <div className="px-20 pb-20 helpDeskSec">
                          <div className="pt-20 pb-3 helpDeskSecTitle">
                            <h5 className="">Helpdesk</h5>
                          </div>
                          {helpdeskDetail?.map((detail) => (
                            <div className="helpDeskDiv d-flex justify-content-between flex-column borderBottom pb-4 mb-20">
                              <div className="d-flex gap-2 align-items-center">
                                <div className="headImg">
                                  {/* <img src={AccountImg} alt="" /> */}
                                  {detail.img ? (
                                    <UserImage imgKey={detail.img} alt={detail.name} />
                                  ) : (
                                    <div>
                                      <img
                                        src={getInitialsInName(detail.name ?? "N A", 40)}
                                        alt={detail.name}
                                      />
                                    </div>
                                  )}
                                </div>
                                <div>
                                  <h6 className="font-medium">{detail.name}</h6>
                                  <p className="text-md text-gray-300 mb-0">
                                    {detail.team}
                                  </p>
                                </div>
                              </div>

                          <div className="mt-2 pt-1 ms-0 helpEmail">
                            <div className="d-flex mb-1">
                              <svg
                                width="1rem"
                                height="1rem"
                                viewBox="0 0 16 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M11.333 13.6667H4.66634C2.66634 13.6667 1.33301 12.6667 1.33301 10.3333V5.66668C1.33301 3.33334 2.66634 2.33334 4.66634 2.33334H11.333C13.333 2.33334 14.6663 3.33334 14.6663 5.66668V10.3333C14.6663 12.6667 13.333 13.6667 11.333 13.6667Z"
                                  stroke="#888888"
                                  stroke-width="1.5"
                                  stroke-miterlimit="10"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M11.3337 6L9.24699 7.66667C8.56032 8.21333 7.43366 8.21333 6.74699 7.66667L4.66699 6"
                                  stroke="#888888"
                                  stroke-width="1.5"
                                  stroke-miterlimit="10"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                              <p className="text-sm ms-2 mb-0">{detail.companyEmail}</p>
                            </div>

                            <div className="d-flex">
                              <svg
                                width="1rem"
                                height="1rem"
                                viewBox="0 0 16 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M14.6463 12.22C14.6463 12.46 14.593 12.7067 14.4797 12.9467C14.3663 13.1867 14.2197 13.4133 14.0263 13.6267C13.6997 13.9867 13.3397 14.2467 12.933 14.4133C12.533 14.58 12.0997 14.6667 11.633 14.6667C10.953 14.6667 10.2263 14.5067 9.45967 14.18C8.69301 13.8533 7.92634 13.4133 7.16634 12.86C6.39967 12.3 5.67301 11.68 4.97967 10.9933C4.29301 10.3 3.67301 9.57334 3.11967 8.81334C2.57301 8.05334 2.13301 7.29334 1.81301 6.54001C1.49301 5.78001 1.33301 5.05334 1.33301 4.36001C1.33301 3.90668 1.41301 3.47334 1.57301 3.07334C1.73301 2.66668 1.98634 2.29334 2.33967 1.96001C2.76634 1.54001 3.23301 1.33334 3.72634 1.33334C3.91301 1.33334 4.09967 1.37334 4.26634 1.45334C4.43967 1.53334 4.59301 1.65334 4.71301 1.82668L6.25967 4.00668C6.37967 4.17334 6.46634 4.32668 6.52634 4.47334C6.58634 4.61334 6.61967 4.75334 6.61967 4.88001C6.61967 5.04001 6.57301 5.20001 6.47967 5.35334C6.39301 5.50668 6.26634 5.66668 6.10634 5.82668L5.59967 6.35334C5.52634 6.42668 5.49301 6.51334 5.49301 6.62001C5.49301 6.67334 5.49967 6.72001 5.51301 6.77334C5.53301 6.82668 5.55301 6.86668 5.56634 6.90668C5.68634 7.12668 5.89301 7.41334 6.18634 7.76001C6.48634 8.10668 6.80634 8.46001 7.15301 8.81334C7.51301 9.16668 7.85967 9.49334 8.21301 9.79334C8.55967 10.0867 8.84634 10.2867 9.07301 10.4067C9.10634 10.42 9.14634 10.44 9.19301 10.46C9.24634 10.48 9.29967 10.4867 9.35967 10.4867C9.47301 10.4867 9.55967 10.4467 9.63301 10.3733L10.1397 9.87334C10.3063 9.70668 10.4663 9.58001 10.6197 9.50001C10.773 9.40668 10.9263 9.36001 11.093 9.36001C11.2197 9.36001 11.353 9.38668 11.4997 9.44668C11.6463 9.50668 11.7997 9.59334 11.9663 9.70668L14.173 11.2733C14.3463 11.3933 14.4663 11.5333 14.5397 11.7C14.6063 11.8667 14.6463 12.0333 14.6463 12.22Z"
                                  stroke="#888888"
                                  stroke-width="1.5"
                                  stroke-miterlimit="10"
                                />
                                <path
                                  d="M12.3333 6.00002C12.3333 5.60002 12.02 4.98669 11.5533 4.48669C11.1267 4.02669 10.56 3.66669 10 3.66669"
                                  stroke="#888888"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M14.6667 6.00001C14.6667 3.42001 12.58 1.33334 10 1.33334"
                                  stroke="#888888"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>

                                  <p className="text-sm mb-0 ms-2">{detail.phoneNumber}</p>
                                </div>
                              </div>
                            </div>
                          ))}
                          {helpdeskDetail?.length === 0 && (
                            <NoData
                              msgicon={'helpdesk'}
                              message={'Helpdesk members will be listed here.'}
                            />
                          )}
                          {/* <div className="d-flex justify-content-between borderBottom pb-4 mb-20">
                        <div className="d-flex gap-2 align-items-center">
                          <div className="headImg">
                            <img src={AccountImg} alt="" />
                          </div>
                          <div>
                            <h6 className="font-medium">John Smith</h6>
                            <p className="text-md text-gray-300 mb-0">
                              Tech lead
                            </p>
                          </div>
                        </div>

                        <div className="borderLeft2 ps-4 helpEmail">
                          <div className="d-flex gap-1 mb-1">
                            <svg
                              width="16"
                              height="16"
                              viewBox="0 0 16 16"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M11.333 13.6667H4.66634C2.66634 13.6667 1.33301 12.6667 1.33301 10.3333V5.66668C1.33301 3.33334 2.66634 2.33334 4.66634 2.33334H11.333C13.333 2.33334 14.6663 3.33334 14.6663 5.66668V10.3333C14.6663 12.6667 13.333 13.6667 11.333 13.6667Z"
                                stroke="#888888"
                                stroke-width="1.5"
                                stroke-miterlimit="10"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M11.3337 6L9.24699 7.66667C8.56032 8.21333 7.43366 8.21333 6.74699 7.66667L4.66699 6"
                                stroke="#888888"
                                stroke-width="1.5"
                                stroke-miterlimit="10"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                            <p className="text-sm mb-0">john@example.com</p>
                          </div>

                          <div className="d-flex gap-1">
                            <svg
                              width="16"
                              height="16"
                              viewBox="0 0 16 16"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M14.6463 12.22C14.6463 12.46 14.593 12.7067 14.4797 12.9467C14.3663 13.1867 14.2197 13.4133 14.0263 13.6267C13.6997 13.9867 13.3397 14.2467 12.933 14.4133C12.533 14.58 12.0997 14.6667 11.633 14.6667C10.953 14.6667 10.2263 14.5067 9.45967 14.18C8.69301 13.8533 7.92634 13.4133 7.16634 12.86C6.39967 12.3 5.67301 11.68 4.97967 10.9933C4.29301 10.3 3.67301 9.57334 3.11967 8.81334C2.57301 8.05334 2.13301 7.29334 1.81301 6.54001C1.49301 5.78001 1.33301 5.05334 1.33301 4.36001C1.33301 3.90668 1.41301 3.47334 1.57301 3.07334C1.73301 2.66668 1.98634 2.29334 2.33967 1.96001C2.76634 1.54001 3.23301 1.33334 3.72634 1.33334C3.91301 1.33334 4.09967 1.37334 4.26634 1.45334C4.43967 1.53334 4.59301 1.65334 4.71301 1.82668L6.25967 4.00668C6.37967 4.17334 6.46634 4.32668 6.52634 4.47334C6.58634 4.61334 6.61967 4.75334 6.61967 4.88001C6.61967 5.04001 6.57301 5.20001 6.47967 5.35334C6.39301 5.50668 6.26634 5.66668 6.10634 5.82668L5.59967 6.35334C5.52634 6.42668 5.49301 6.51334 5.49301 6.62001C5.49301 6.67334 5.49967 6.72001 5.51301 6.77334C5.53301 6.82668 5.55301 6.86668 5.56634 6.90668C5.68634 7.12668 5.89301 7.41334 6.18634 7.76001C6.48634 8.10668 6.80634 8.46001 7.15301 8.81334C7.51301 9.16668 7.85967 9.49334 8.21301 9.79334C8.55967 10.0867 8.84634 10.2867 9.07301 10.4067C9.10634 10.42 9.14634 10.44 9.19301 10.46C9.24634 10.48 9.29967 10.4867 9.35967 10.4867C9.47301 10.4867 9.55967 10.4467 9.63301 10.3733L10.1397 9.87334C10.3063 9.70668 10.4663 9.58001 10.6197 9.50001C10.773 9.40668 10.9263 9.36001 11.093 9.36001C11.2197 9.36001 11.353 9.38668 11.4997 9.44668C11.6463 9.50668 11.7997 9.59334 11.9663 9.70668L14.173 11.2733C14.3463 11.3933 14.4663 11.5333 14.5397 11.7C14.6063 11.8667 14.6463 12.0333 14.6463 12.22Z"
                                stroke="#888888"
                                stroke-width="1.5"
                                stroke-miterlimit="10"
                              />
                              <path
                                d="M12.3333 6.00002C12.3333 5.60002 12.02 4.98669 11.5533 4.48669C11.1267 4.02669 10.56 3.66669 10 3.66669"
                                stroke="#888888"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M14.6667 6.00001C14.6667 3.42001 12.58 1.33334 10 1.33334"
                                stroke="#888888"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>

                            <p className="text-sm mb-0">(+1) 123 456 7890</p>
                          </div>
                        </div>
                      </div>

                      <div className="d-flex justify-content-between pb-4 mb-20">
                        <div className="d-flex gap-2 align-items-center">
                          <div className="headImg">
                            <img src={AccountImg} alt="" />
                          </div>
                          <div>
                            <h6 className="font-medium">John Smith</h6>
                            <p className="text-md text-gray-300 mb-0">
                              Tech lead
                            </p>
                          </div>
                        </div>

                        <div className="borderLeft2 ps-4 helpEmail">
                          <div className="d-flex gap-1 mb-1">
                            <svg
                              width="16"
                              height="16"
                              viewBox="0 0 16 16"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M11.333 13.6667H4.66634C2.66634 13.6667 1.33301 12.6667 1.33301 10.3333V5.66668C1.33301 3.33334 2.66634 2.33334 4.66634 2.33334H11.333C13.333 2.33334 14.6663 3.33334 14.6663 5.66668V10.3333C14.6663 12.6667 13.333 13.6667 11.333 13.6667Z"
                                stroke="#888888"
                                stroke-width="1.5"
                                stroke-miterlimit="10"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M11.3337 6L9.24699 7.66667C8.56032 8.21333 7.43366 8.21333 6.74699 7.66667L4.66699 6"
                                stroke="#888888"
                                stroke-width="1.5"
                                stroke-miterlimit="10"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                            <p className="text-sm mb-0">john@example.com</p>
                          </div>

                          <div className="d-flex gap-1">
                            <svg
                              width="16"
                              height="16"
                              viewBox="0 0 16 16"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M14.6463 12.22C14.6463 12.46 14.593 12.7067 14.4797 12.9467C14.3663 13.1867 14.2197 13.4133 14.0263 13.6267C13.6997 13.9867 13.3397 14.2467 12.933 14.4133C12.533 14.58 12.0997 14.6667 11.633 14.6667C10.953 14.6667 10.2263 14.5067 9.45967 14.18C8.69301 13.8533 7.92634 13.4133 7.16634 12.86C6.39967 12.3 5.67301 11.68 4.97967 10.9933C4.29301 10.3 3.67301 9.57334 3.11967 8.81334C2.57301 8.05334 2.13301 7.29334 1.81301 6.54001C1.49301 5.78001 1.33301 5.05334 1.33301 4.36001C1.33301 3.90668 1.41301 3.47334 1.57301 3.07334C1.73301 2.66668 1.98634 2.29334 2.33967 1.96001C2.76634 1.54001 3.23301 1.33334 3.72634 1.33334C3.91301 1.33334 4.09967 1.37334 4.26634 1.45334C4.43967 1.53334 4.59301 1.65334 4.71301 1.82668L6.25967 4.00668C6.37967 4.17334 6.46634 4.32668 6.52634 4.47334C6.58634 4.61334 6.61967 4.75334 6.61967 4.88001C6.61967 5.04001 6.57301 5.20001 6.47967 5.35334C6.39301 5.50668 6.26634 5.66668 6.10634 5.82668L5.59967 6.35334C5.52634 6.42668 5.49301 6.51334 5.49301 6.62001C5.49301 6.67334 5.49967 6.72001 5.51301 6.77334C5.53301 6.82668 5.55301 6.86668 5.56634 6.90668C5.68634 7.12668 5.89301 7.41334 6.18634 7.76001C6.48634 8.10668 6.80634 8.46001 7.15301 8.81334C7.51301 9.16668 7.85967 9.49334 8.21301 9.79334C8.55967 10.0867 8.84634 10.2867 9.07301 10.4067C9.10634 10.42 9.14634 10.44 9.19301 10.46C9.24634 10.48 9.29967 10.4867 9.35967 10.4867C9.47301 10.4867 9.55967 10.4467 9.63301 10.3733L10.1397 9.87334C10.3063 9.70668 10.4663 9.58001 10.6197 9.50001C10.773 9.40668 10.9263 9.36001 11.093 9.36001C11.2197 9.36001 11.353 9.38668 11.4997 9.44668C11.6463 9.50668 11.7997 9.59334 11.9663 9.70668L14.173 11.2733C14.3463 11.3933 14.4663 11.5333 14.5397 11.7C14.6063 11.8667 14.6463 12.0333 14.6463 12.22Z"
                                stroke="#888888"
                                stroke-width="1.5"
                                stroke-miterlimit="10"
                              />
                              <path
                                d="M12.3333 6.00002C12.3333 5.60002 12.02 4.98669 11.5533 4.48669C11.1267 4.02669 10.56 3.66669 10 3.66669"
                                stroke="#888888"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M14.6667 6.00001C14.6667 3.42001 12.58 1.33334 10 1.33334"
                                stroke="#888888"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>

                            <p className="text-sm mb-0">(+1) 123 456 7890</p>
                          </div>
                        </div>
                      </div> */}
                        </div>
                      </div>
                    </Col>
                    <Col lg={8} className="yourJourny">
                      <div className="page flex-grow-1 d-flex">
                        <Row className="g-0 py-32 w-100 d-flex column px-46">
                          <Col lg={12} className=" d-flex flex-column">
                            {/* <h5 className="mb-3">The modules you have started will be listed here.</h5> */}
                            <h5 className="mb-3">Resume your Journey</h5>
                            <div className="flex-grow-1 em100">
                              {filteredEmployees && filteredEmployees.length > 0 ? (
                                <>
                                {(filteredEmployees.length === 1 || filteredEmployees.length === 2)  && (
                                    <>
                                      {filteredEmployees.map((assignment, index) => (
                                          <div className="mb-3">
                                          <EmpDashboardCardLarge
                                            key={index}
                                            assignment={assignment}
                                            filteredEmployees={filteredEmployees}
                                            JournyImg={randomImage}
                                          />
                                          </div>
                                        ))}
                                    </>
                                  )}

                                  {filteredEmployees.length === 3 && (
                                    <>
                                    {/* <h1>hello</h1> */}
                                    {filteredEmployees?.slice(0, 1)
                                        .map((assignment, index) => (
                                          <div className="mb-3">
                                            <EmpDashboardCardLarge
                                              key={index}
                                              assignment={assignment}
                                              filteredEmployees={filteredEmployees}
                                              JournyImg={randomImage}
                                            />
                                          </div>
                                        ))}
                                    <Row>
                                      {filteredEmployees?.slice(1, 3)
                                        .map((assignment, index) => (
                                          <>
                                          <Col md={6} key={index}>
                                            <EmpDashboardCard
                                              assignment={assignment}
                                              filteredEmployees={filteredEmployees}
                                              image={randomImage}
                                            />
                                          </Col>
                                          </>
                                        ))}
                                        </Row>
                                    </>
                                  )}

                                  {/* <Col md={6}><EmpDashboardCard image={JournyImg2}/></Col> */}
                                  {/* {filteredEmployees && filteredEmployees.length > 0 ? (
                                      <>
                                        <div> */}
                                  {filteredEmployees.length > 3 && filteredEmployees?.slice(0, 1)?.map((assignment, index) => (
                                  <div className="journyCardshadow mb-3">
                                    <Row className="g-0 align-items-center">
                                        <EmpDashboardCardLarge
                                            key={index}
                                            assignment={assignment}
                                            filteredEmployees={filteredEmployees}
                                            JournyImg={randomImage}
                                          />
                                    </Row>
                                  </div>
                                  ))}

                                  <Row className="g-0 mx-1m">
                                    {filteredEmployees.length > 3 && (
                                      <>
                                        {settings && (
                                          <Slider className="postSlider" {...settings}>
                                            {filteredEmployees?.slice(1)?.map((assignment, index) => {
                                              const imageSources = [JournyImg, JournyImg1, JournyImg2, JournyImg3, journyImg4, JournyImg5, JournyImg6, JournyImg7, journyImg8, JournyImg9, JournyImg10, journyImg11, journyImg12, JournyImg13, JournyImg14, journyImg15];
                                              const randomIndex = Math.floor(Math.random() * imageSources.length);
                                              const randomImage = imageSources[randomIndex];
                                              return (
                                                <Col md={6} key={index} className="px-2 flex-column d-flex flex-grow-1">
                                                  <EmpDashboardCard
                                                    assignment={assignment}
                                                    filteredEmployees={filteredEmployees}
                                                    image={randomImage}
                                                  />
                                                </Col>
                                              );
                                            })}
                                          </Slider>
                                        )}
                                      </>
                                    )}
                                  </Row>
                                </>
                              ) : (
                                <NoData msgicon={'resume'} message={'The modules you have started will be listed here.'} />
                              )}

                            </div>

                          </Col>
                        </Row>

                      </div>
                    </Col>
                  </Row>

                </div>


              </Container>
            </div>
          </div >

          <Modal
            className="uPass"
            size="md"
            centered
            show={updatePassword}
          >
            {updatePassword && (
              <UpdatePassword
                onClose={setUpdatePassword}
                isPasswordNotSet={userProfile?.isPasswordNotSet}
                oldPasswords={userProfiles?.password}
              />
            )}
          </Modal></>
      )}
    </>
  );
};

export default EmployeeDashboard;
